export enum Transitions {
  FADE = 'fade',
  ZOOM = 'zoom',
}



// WEBPACK FOOTER //
// ./src/components/modal/default/types.ts